<!-- commented out temporarily per Eric on 3/9/2018
  <div *ngIf="hasContent" class="section">
  <div class="section__header">
    <h2 class="section__header-text">Example Fees</h2>
  </div>
  <div class="section__sub-header">
    <div class="section__sub-header-text">
      Fees shown here are examples of common airframes and fee types.
      Additional fees may also be charged.
      See the Fee Details section below for a comprehensive list of all known fees.
    </div>
  </div>
  <div class="section__body">
    <app-summary-fees [overviewFees]="business.overviewFees"></app-summary-fees>
  </div>
  <div class="section__footer" *ngIf="business.overviewFees && business.overviewFees.length && business.feesLastUpdate">
    <div class="fee-section-summary__disclaimers"><em>Fees Last Updated: {{ business.feesLastUpdate | date:'M/d/yyyy'}}</em></div>
  </div>
</div> -->

<app-business-fees *ngIf="hasContent || isEditModeSet" id="feesdetail" [business]="business" [editModeSet]="isEditModeSet" [fees]="business.services" [feesLastUpdate]="business.feesLastUpdate"></app-business-fees>
